/** GraphQL Query that fetches store configuration from the API */
export const StoreConfigQuery = `
  query storeConfig {
    storeConfig {
        store_code,
        default_title,
        store_name,
        default_display_currency_code,
        locale,
        header_logo_src,
        logo_width,
        logo_height,
        logo_alt,
        copyright,
        show_top_notification,
        top_notification_content,
        top_notification_background_color,
        top_notification_additional_style,
        icp_number,
        icp_link,
        policy_beian_enable,
        policy_beian_number,
        policy_beian_link,
    }
  }
`;

export default StoreConfigQuery;
